export default {
    "html" : require("./html").default,
    "js": require("./js").default,
    "minJs": require("./minJs").default
}